import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-case-manager',
    templateUrl: './mnews-dist.component.html',
    styleUrls: ['./mnews-dist.component.css']
})
export class MnewsDistComponent implements OnInit {

    constructor() {
    }


    ngOnInit() {
    }

}
